import { IconButton } from '@mui/material'

import { PlusIcon } from 'src/assets/icons'

import useStyles from './styles'

interface IStubImageButtonProps {
  handleClick: () => void
  isModal?: boolean
  disabled?: boolean
}

const StubImageButton = ({ handleClick, isModal, disabled }: IStubImageButtonProps) => {
  const classes = useStyles({ isModalImage: isModal })

  return (
    <IconButton className={classes.imageIconWrapper} onClick={handleClick} disabled={disabled}>
      <PlusIcon className={classes.imageIcon} />
    </IconButton>
  )
}

export { StubImageButton }
